<template>
  <button
    :class="{
      button: true,
      logIn: variant === 'logIn',
      filled: variant === 'filled',
      bordered: variant === 'bordered',
      wideBordered: variant === 'wideBordered',
      borderedBackground: variant === 'borderedBackground',
      borderedInactive: variant === 'borderedInactive',
      notBordered: variant === 'notBordered',
      redButton: variant === 'redButton',
      yellowButton: variant === 'yellowButton',
      disabled: variant === 'disabled',
      disabledBackground: variant === 'disabledBackground',
      disabledLong: variant === 'disabledLong',
      disabledNotBordered: variant === 'disabledNotBordered',
      search: variant === 'search',
      redBordered: variant === 'redBordered',
      redBorderedBackground: variant === 'redBorderedBackground',
      blackButton: variant === 'blackButton',
      authenticated: variant === 'authenticated',
      authenticationFailed: variant === 'authenticationFailed',
      userNotFound: variant === 'userNotFound',
      authenticationPending: variant === 'authenticationPending',
      userFound: variant === 'userFound',
      paymentCompleted: variant === 'paymentCompleted',
      paymentFailed: variant === 'paymentFailed',
      cancelled: variant === 'cancelled',
      paymentPending: variant === 'paymentPending',
      paymentNotificationWasSuccessfullyResend:
        variant === 'paymentNotificationWasSuccessfullyResend'
    }"
    :type="type || 'button'"
  >
    <img
      v-if="
        $route.name === 'CallerAuthentication' &&
        (title === $t('authenticated') ||
          title === $t('paymentCompleted' || title === $t('userFound')))
      "
      class="imgAuth"
      src="@/assets/icons/Authenticated.svg"
      alt="Check"
    />
    <img
      v-if="
        $route.name === 'CallerAuthentication' &&
        (title === $t('authenticationFailed') ||
          title === $t('userNotFound') ||
          title === $t('paymentFailed') ||
          title === $t('cancelled'))
      "
      class="imgAuthFailed"
      src="@/assets/icons/AuthenticationFailed.svg"
      alt="Check"
    />
    <img
      v-if="
        $route.name === 'ViewOrder' &&
        title === $t('paymentNotificationWasSuccessfullyResend')
      "
      class="imgPaymentNotificationWasSuccessfullyResend"
      src="@/assets/icons/PaymentNotificationWasSuccessfullyResend.svg"
      alt="Check"
    />
    <LoadingForAuthentication
      v-if="
        ($route.name === 'CallerAuthentication' &&
          title === $t('authenticationPending')) ||
        title === $t('paymentPending')
      "
    />
    {{ title }}
    <img
      v-if="$route.name === 'DeliveryHistory' && title === $t('pickedUp')"
      class="img"
      src="@/assets/icons/PickedUpReservation.svg"
      alt="Picked Up DeliveryHistory"
    />
  </button>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'Button',
  props: ['type', 'title', 'variant']
})
export default class ButtonComponent extends Vue {}
</script>

<style lang="scss" scoped>
button {
  width: 125px;
  height: 42px;
  border: none;
  border-radius: 8px;
  font-size: $fourteenSize;
  line-height: $fourteenSize;
  cursor: pointer;
  .img {
    height: 18px;
    width: 18px;
    opacity: 1;
    filter: invert(100%);
    background-color: $backgroundImg;
  }
  .imgAuth {
    display: flex;
    align-items: center;
    background-color: $authenticated;
    margin-right: 10px;
  }
  .imgPaymentNotificationWasSuccessfullyResend {
    background-color: $main-green;
    margin-right: 10px;
  }
  .imgAuthFailed {
    display: flex;
    align-items: center;
    background-color: $backgroundImgAuthFailed;
    margin-right: 10px;
  }
  &.logIn {
    width: 352px;
    background-color: $main-green;
    color: $white;
    &:hover {
      background-color: $button;
    }
  }
  &.filled {
    background-color: $main-green;
    color: $white;
    &:hover {
      background-color: $button;
    }
    &:hover .imgPaymentNotificationWasSuccessfullyResend {
      background-color: $backgroundImgWasSuccessfully;
    }
  }
  &.search {
    width: 80px;
    border-radius: 0;
    background-color: $main-green;
    color: $white;
    &:hover {
      background-color: $button;
    }
  }
  &.bordered {
    background-color: $white;
    color: $main-green;
    border: 1px solid $main-green;
    &:hover {
      color: $button;
      border-color: $button;
    }
  }
  &.wideBordered {
    background-color: $white;
    color: $main-green;
    border: 1px solid $main-green;
    width: 186px;
    &:hover {
      color: $button;
      border-color: $button;
    }
  }
  &.borderedBackground {
    background-color: $light-grey;
    color: $main-green;
    border: 1px solid $main-green;
    &:hover {
      color: $button;
      border-color: $button;
    }
  }
  &.notBordered {
    font-family: 'Ubuntu-Medium';
    color: $main-green;
    background-color: $white;
    &:hover {
      color: $dark-green;
    }
  }
  &.borderedInactive {
    border: 1px solid $grey;
    background-color: $white;
    color: $borderedInactive;
  }
  &:disabled {
    border-color: $grey;
    color: $grey;
  }
  &.redButton {
    color: $white;
    background-color: $red;
    &:hover {
      background: $dark-red;
    }
  }
  &.yellowButton {
    color: $white;
    background-color: $yellow;
    &:hover {
      background: $dark-yellow;
    }
  }
  &.blackButton {
    color: $label;
    background-color: $white;
  }
  &.authenticated,
  &.paymentCompleted,
  &.userFound {
    display: flex;
    align-items: center;
    justify-content: center;
    color: $colorCompleted;
    background-color: $authenticated;
  }
  &.authenticationFailed,
  &.paymentFailed,
  &.cancelled,
  &.userNotFound {
    display: flex;
    align-items: center;
    justify-content: center;
    color: $colorFailed;
    background-color: $backgroundPaymentFailed;
  }
  &.authenticationPending,
  &.paymentPending {
    position: relative;
    color: $colorPending;
    background-color: $backgroundPending;
  }
  &.disabled {
    color: $grey;
    border: 1px solid $checkbox-border;
    background-color: $white;
    cursor: default;
  }
  &.disabledBackground {
    color: $white;
    background-color: $disabledBackground;
    border: 1px solid $disabledBackground;
    cursor: default;
  }
  &.disabledLong {
    border: 1px solid $checkbox-border;
    background-color: $white;
    width: 165px;
    cursor: default;
  }
  &.disabledNotBordered {
    background-color: $white;
    cursor: default;
  }
  &.redBordered {
    color: $red;
    border: 1px solid $red;
    &:hover {
      border: 1px solid $dark-red;
    }
  }
  &.redBorderedBackground {
    width: 158px;
    color: $red;
    border: 1px solid $red;
    background-color: $light-grey;
    &:hover {
      border: 1px solid $dark-red;
    }
  }
}

.btn:focus {
  box-shadow: none;
}
</style>
